import { forceUpdate, Fragment, h, } from "@stencil/core";
import { getTranslation, hasSlot, JsonParser, isMobile, ResizeListener, } from "@ace/web-components/dist_lib/utils";
import { getAceBettingFilterBarNames, aceBettingFilterBarSlots } from "./ace-betting-filter-bar.get-names";
const DEFAULT_TRANSLATIONS = {
    sort_button: 'Sortieren',
    filter_button: 'Filtern',
    sort_overlay_headline: 'Sortieren nach',
    filter_overlay_headline: 'Filtern nach',
    cancel_button: 'Abbrechen',
    apply_button: 'Übernehmen'
};
export class AceBettingFilterBar {
    constructor() {
        this.variant = 'table';
        this.filterViewOpen = false;
        this.sortViewOpen = false;
        this.selectedFilterOption = null;
        this.selectedSortOption = null;
        this._filterOptions = [];
        this._sortOptions = [];
        this.isMobile = false;
        this.hasFilterButton = false;
        this.loadScreenSize = ({ windowWidth }) => {
            this.isMobile = isMobile(windowWidth);
        };
    }
    componentWillLoad() {
        var _a;
        this.names = getAceBettingFilterBarNames((_a = this.hostElement) === null || _a === void 0 ? void 0 : _a.id);
        this.parseFilterOptions();
        this.parseSortOptions();
        this.parseTranslations();
        ResizeListener.getInstance().subscribe(this.loadScreenSize);
    }
    disconnectedCallback() {
        ResizeListener.getInstance().unsubscribe(this.loadScreenSize);
    }
    parseTranslations() {
        this._translations = new JsonParser(this.translations, {}).getValue();
    }
    parseFilterOptions() {
        this._filterOptions = new JsonParser(this.filterOptions, []).getValue();
        this._filterOptions.forEach(option => {
            if (option.selected) {
                this.selectedFilterOption = option;
            }
        });
        this.hasFilterButton = this._filterOptions.length > 3;
    }
    parseSortOptions() {
        this._sortOptions = new JsonParser(this.sortOptions, []).getValue();
        if (!this.selectedSortOption) {
            this._sortOptions.forEach(option => {
                if (option.selected) {
                    this.selectedSortOption = option;
                }
            });
        }
    }
    renderColumnSlots() {
        if (this.variant === 'table') {
            const filterSlots = [aceBettingFilterBarSlots.FIRST_FILTER, aceBettingFilterBarSlots.SECOND_FILTER, aceBettingFilterBarSlots.THIRD_FILTER, aceBettingFilterBarSlots.FOURTH_FILTER];
            return (h("div", { class: this.names.CLASS.FILTERS__SLOTS }, filterSlots.map(slotName => hasSlot(this.hostElement, slotName) && (h("div", { class: this.names.CLASS.FILTERS__SLOTS__EL }, h("slot", { name: slotName }))))));
        }
    }
    /**
     *
     * @param e
     * @param option
     * @param triggerReRender
     * @private
     */
    selectFilterOption(e, option, triggerReRender = false) {
        e.preventDefault();
        if (option && (!this.selectedFilterOption || (option.value !== this.selectedFilterOption.value))) {
            this.selectedFilterOption = option;
            this.selectedFilterOption.selected = true;
            this.filterOptionSelected.emit(this.selectedFilterOption);
            if (triggerReRender) {
                forceUpdate(this);
            }
        }
        // This is for the case when it comes from the filter modal.
        if (!triggerReRender) {
            this.toggleFilterModal(e);
        }
    }
    /**
     *
     * @param e
     * @private
     */
    toggleFilterModal(e) {
        e.preventDefault();
        this.filterViewOpen = !this.filterViewOpen;
        if (this.filterViewOpen) {
            this.filterOverlayOpened.emit();
        }
        else {
            this.filterOverlayClosed.emit();
        }
    }
    /**
     *
     * @param e
     * @private
     */
    toggleSortModal(e) {
        e.preventDefault();
        this.sortViewOpen = !this.sortViewOpen;
        if (this.sortViewOpen) {
            this.sortOverlayOpened.emit();
        }
        else {
            this.sortOverlayClosed.emit();
        }
    }
    renderToggleButtonFilters() {
        if (this._filterOptions && this._filterOptions.length > 0) {
            return (h("div", { class: this.names.CLASS.FILTERS__BAR }, this._filterOptions.map(option => {
                const isSelectedFilterOption = this.selectedFilterOption && this.selectedFilterOption.value === option.value;
                return (h("ace-toggle-button", { size: 'small', id: `${this.names.ID.ROOT}-bar-filter-option-${option.value}`, active: isSelectedFilterOption, "toggle-on-click": 'false', onButtonClicked: e => this.selectFilterOption(e, option, true) }, option.label));
            })));
        }
    }
    renderFilterButton() {
        if (!this.hasFilterButton) {
            return;
        }
        const renderAllFilterOptions = () => {
            return (h("ace-betting-bottom-tray", { open: this.filterViewOpen, onBottomTrayClosed: (e) => this.toggleFilterModal(e) }, h("div", { class: this.names.CLASS.FILTERS__BOTTOM_TRAY }, h("ace-headline", { type: 'h2', class: this.names.CLASS.FILTERS__BOTTOM_TRAY__HEADLINE }, getTranslation(this._translations, 'filter_overlay_headline', DEFAULT_TRANSLATIONS)), h("div", { class: this.names.CLASS.FILTERS__BOTTOM_TRAY__ITEMS }, this._filterOptions.map((option) => {
                let cssClasses = {
                    [this.names.CLASS.FILTERS__BOTTOM_TRAY__ITEMS__EL]: true,
                    [this.names.CLASS.FILTERS__BOTTOM_TRAY__ITEMS__EL____SELECTED]: this.selectedFilterOption && option.value === this.selectedFilterOption.value
                };
                return h("button", { class: cssClasses, id: `${this.names.ID.ROOT}-overlay-filter-option-${option.value}`, onClick: (e) => this.selectFilterOption(e, option) }, option.label);
            })))));
        };
        return (h(Fragment, null, renderAllFilterOptions(), h("div", { class: this.names.CLASS.FILTERS__BUTTON }, h("ace-toggle-button", { size: 'small', active: this.filterViewOpen, "icon-name": 'filter', id: `${this.names.ID.ROOT}-toggle-filter`, onButtonClicked: (e) => this.toggleFilterModal(e), name: getTranslation(this._translations, 'filter_button', DEFAULT_TRANSLATIONS) }))));
    }
    /**
     *
     * @param e
     * @param option
     * @private
     */
    selectSortingOption(e, option) {
        e.preventDefault();
        if (option && (!this.selectedSortOption || (option.value !== this.selectedSortOption.value))) {
            this.selectedSortOption = option;
            this.selectedSortOption.selected = true;
            this.sortOptionSelected.emit(this.selectedSortOption);
        }
        this.toggleSortModal(e);
    }
    /**
     *
     * @private
     */
    renderSortButtonAndOptions() {
        if (this._sortOptions.length === 0) {
            return;
        }
        const getSortOptionId = (option) => {
            return `${this.names.ID.ROOT}-sort-option-${option.value}`;
        };
        const renderMobileSortView = () => {
            let radioButtonName = `${this.names.ID.ROOT}-radio-button`;
            let optionSelected = this.selectedSortOption;
            const onSortOptionSelected = (item) => {
                optionSelected = this._sortOptions.find((option) => option.value === item.value);
            };
            return (h("ace-betting-bottom-tray", { open: this.sortViewOpen, "close-on-overlay-click": 'false', onBottomTrayClosed: (e) => this.toggleSortModal(e) }, h("div", { class: this.names.CLASS.SORT__BOTTOM_TRAY }, h("ace-headline", { type: 'h2' }, getTranslation(this._translations, 'sort_overlay_headline', DEFAULT_TRANSLATIONS)), h("div", { class: this.names.CLASS.SORT__BOTTOM_TRAY__ITEMS }, this._sortOptions.map((option) => {
                return h("ace-radio-button", { name: radioButtonName, value: option.value, id: getSortOptionId(option), label: option.label, checked: optionSelected && optionSelected.value === option.value, onSelected: (event) => onSortOptionSelected(event.detail) });
            }))), h("div", { class: this.names.CLASS.SORT__BOTTOM_TRAY__ACTIONS, slot: 'footer' }, h("ace-button", { type: 'secondary', "full-width-mobile": 'true', id: `${this.names.ID.ROOT}-cancel-sort`, onButtonClicked: (e) => this.toggleSortModal(e) }, getTranslation(this._translations, 'cancel_button', DEFAULT_TRANSLATIONS)), h("ace-button", { "full-width-mobile": 'true', id: `${this.names.ID.ROOT}-apply-sort`, onButtonClicked: (e) => this.selectSortingOption(e, optionSelected) }, getTranslation(this._translations, 'apply_button', DEFAULT_TRANSLATIONS)))));
        };
        const renderNonMobileSortView = () => {
            if (this.sortViewOpen) {
                return (h("div", { class: this.names.CLASS.SORT__ITEMS }, this._sortOptions.map((option) => {
                    var _a;
                    let finalCssClasses = {
                        [this.names.CLASS.SORT__ITEMS__EL]: true,
                        [this.names.CLASS.SORT__ITEMS__EL____SELECTED]: this.selectedSortOption && option.value === ((_a = this.selectedSortOption) === null || _a === void 0 ? void 0 : _a.value)
                    };
                    return h("button", { class: finalCssClasses, id: getSortOptionId(option), onClick: (e) => this.selectSortingOption(e, option) }, option.label);
                })));
            }
        };
        return (h(Fragment, null, h("div", { class: this.names.CLASS.SORT__BUTTON }, h("ace-toggle-button", { size: 'small', active: this.sortViewOpen, id: `${this.names.ID.ROOT}-toggle-sort`, "icon-name": 'sorting', type: 'hidden', onButtonClicked: (e) => this.toggleSortModal(e), name: getTranslation(this._translations, 'sort_button', DEFAULT_TRANSLATIONS) })), this.isMobile ? renderMobileSortView() : renderNonMobileSortView()));
    }
    render() {
        const finalCssClasses = {
            [this.names.CLASS.ROOT]: true,
            [this.names.CLASS.____WITH_FILTER_BUTTON]: this.hasFilterButton,
            [this.names.CLASS.____GRID_VARIANT]: this.variant === 'grid',
            [this.names.CLASS.____FILTER_MODAL_OPEN]: this.filterViewOpen
        };
        return (h("div", { key: '0d62ecc84da579a054addd232f59f0c28c47674c', id: this.names.ID.ROOT, class: finalCssClasses }, this.renderSortButtonAndOptions(), (this.isMobile || this.variant === 'grid') && this.renderToggleButtonFilters(), !this.isMobile && this.renderColumnSlots(), this.isMobile && this.renderFilterButton()));
    }
    static get is() { return "ace-betting-filter-bar"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["./ace-betting-filter-bar.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ace-betting-filter-bar.css"]
        };
    }
    static get properties() {
        return {
            "variant": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "IAceBettingFilterBarVariant",
                    "resolved": "\"grid\" | \"table\"",
                    "references": {
                        "IAceBettingFilterBarVariant": {
                            "location": "import",
                            "path": "./ace-betting-filter-bar.types",
                            "id": "src/components/ace-betting-filter-bar/ace-betting-filter-bar.types.ts::IAceBettingFilterBarVariant"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "variant",
                "reflect": false,
                "defaultValue": "'table'"
            },
            "filterOptions": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string | IAceBettingFilterBarOption[]",
                    "resolved": "IAceBettingFilterBarOption[] | string",
                    "references": {
                        "IAceBettingFilterBarOption": {
                            "location": "import",
                            "path": "./ace-betting-filter-bar.types",
                            "id": "src/components/ace-betting-filter-bar/ace-betting-filter-bar.types.ts::IAceBettingFilterBarOption"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "filter-options",
                "reflect": false
            },
            "sortOptions": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string | IAceBettingFilterBarSortOption[]",
                    "resolved": "IAceBettingFilterBarSortOption[] | string",
                    "references": {
                        "IAceBettingFilterBarSortOption": {
                            "location": "import",
                            "path": "./ace-betting-filter-bar.types",
                            "id": "src/components/ace-betting-filter-bar/ace-betting-filter-bar.types.ts::IAceBettingFilterBarSortOption"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "sort-options",
                "reflect": false
            },
            "translations": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string |IAceBettingFilterBarTranslations",
                    "resolved": "string | { sort_button?: string; filter_button?: string; sort_overlay_headline?: string; filter_overlay_headline?: string; cancel_button?: string; apply_button?: string; }",
                    "references": {
                        "IAceBettingFilterBarTranslations": {
                            "location": "import",
                            "path": "./ace-betting-filter-bar.types",
                            "id": "src/components/ace-betting-filter-bar/ace-betting-filter-bar.types.ts::IAceBettingFilterBarTranslations"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "translations",
                "reflect": false
            }
        };
    }
    static get states() {
        return {
            "filterViewOpen": {},
            "sortViewOpen": {},
            "isMobile": {}
        };
    }
    static get events() {
        return [{
                "method": "filterOptionSelected",
                "name": "filterOptionSelected",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "IAceBettingFilterBarOption",
                    "resolved": "{ label: string; value: string; selected?: boolean; id?: string; }",
                    "references": {
                        "IAceBettingFilterBarOption": {
                            "location": "import",
                            "path": "./ace-betting-filter-bar.types",
                            "id": "src/components/ace-betting-filter-bar/ace-betting-filter-bar.types.ts::IAceBettingFilterBarOption"
                        }
                    }
                }
            }, {
                "method": "filterOverlayOpened",
                "name": "filterOverlayOpened",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "filterOverlayClosed",
                "name": "filterOverlayClosed",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "sortOverlayOpened",
                "name": "sortOverlayOpened",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "sortOverlayClosed",
                "name": "sortOverlayClosed",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "sortOptionSelected",
                "name": "sortOptionSelected",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "IAceBettingFilterBarSortOption",
                    "resolved": "{ value: string; label: string; selected?: boolean; }",
                    "references": {
                        "IAceBettingFilterBarSortOption": {
                            "location": "import",
                            "path": "./ace-betting-filter-bar.types",
                            "id": "src/components/ace-betting-filter-bar/ace-betting-filter-bar.types.ts::IAceBettingFilterBarSortOption"
                        }
                    }
                }
            }];
    }
    static get elementRef() { return "hostElement"; }
    static get watchers() {
        return [{
                "propName": "translations",
                "methodName": "parseTranslations"
            }, {
                "propName": "filterOptions",
                "methodName": "parseFilterOptions"
            }, {
                "propName": "sortOptions",
                "methodName": "parseSortOptions"
            }];
    }
}
//# sourceMappingURL=ace-betting-filter-bar.js.map
